__turbopack_context__.v({
  "postal-code": "PostalCodeAndTown-module-scss-module__TMZmUa__postal-code",
});
